import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import EN from 'date-fns/locale/en-US';
import FR from 'date-fns/locale/fr-CA';
import { getPathVariables, localeEn } from '../misc';

registerLocale('en-US', EN);
registerLocale('fr-CA', FR);

const LocaleContext = createContext();
const LocaleActionsContext = createContext();

export const useLocaleContext = () => useContext(LocaleContext);
export const useLocaleActionsContext = () => useContext(LocaleActionsContext);

const LocaleContextProvider = ({ children }) => {
  const [locale, setLocale] = useState(
    getPathVariables(window.location.pathname)[0] || localeEn
  );

  useEffect(() => {
    setDefaultLocale(locale);
    document.documentElement.lang = locale.slice(0, 2);
  }, [locale]);

  return (
    <LocaleContext.Provider value={locale}>
      <LocaleActionsContext.Provider value={setLocale}>
        {children}
      </LocaleActionsContext.Provider>
    </LocaleContext.Provider>
  );
};

LocaleContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default LocaleContextProvider;
